import type { SearchIntent } from '@/types/search-intent'
import type { RunEntry, SetupRun } from '@/types/setup-run'

export const SEARCH_SNAPSHOT_STAGES = ['measure', 'save'] as const

type SearchSnapshotStage = (typeof SEARCH_SNAPSHOT_STAGES)[number]

export const SEARCH_SNAPSHOT_SCOPES = ['brand-only', 'all'] as const

type SearchSnapshotScope = (typeof SEARCH_SNAPSHOT_SCOPES)[number]

export const SEARCH_SNAPSHOT_ROLES = ['brand', 'rival'] as const

type SearchSnapshotRole = (typeof SEARCH_SNAPSHOT_ROLES)[number]

export interface SearchSnapshotDomainEntry extends RunEntry {
  readonly domain: string
  readonly role: SearchSnapshotRole
  readonly rows?: number
}

export const SEARCH_SNAPSHOT_RUN_STALE_AFTER_MS = 10 * 60 * 1000

export interface SearchSnapshotRun extends SetupRun<
  SearchSnapshotStage,
  SearchSnapshotDomainEntry
> {
  readonly scope: SearchSnapshotScope
  readonly startedByUserId: string | null
  readonly errorCode?: string
  readonly tailErrorCode?: string
}

export interface SearchMonth {
  readonly y: number
  readonly m: number
}

export interface SearchSnapshotRow {
  readonly keyword: string
  readonly coreKeyword: string | null
  readonly volume: number | null
  readonly difficulty: number | null
  readonly intent: SearchIntent | null
  readonly history: { readonly from: SearchMonth; readonly values: readonly number[] } | null
  readonly position: number
  readonly url: string | null
  readonly relativeUrl: string | null
  readonly etv: number | null
  readonly citesAiOverview: boolean
  readonly hasAiOverview: boolean
}

export interface SearchSnapshotPage {
  readonly url: string
  readonly etv: number | null
  readonly count: number | null
}

export interface SearchSnapshotSummary {
  readonly domain: string
  readonly domainKey: string
  readonly competitorId: string | null
  readonly role: SearchSnapshotRole
  readonly runId: string
  readonly fetchedAt: string
  readonly rowCount: number
  readonly pageCount: number
  readonly objectPath: string
}

export interface SearchSnapshotObject {
  readonly domain: string
  readonly competitorId: string | null
  readonly role: SearchSnapshotRole
  readonly runId: string
  readonly fetchedAt: string
  readonly pages: readonly SearchSnapshotPage[]
  readonly rows: readonly SearchSnapshotRow[]
}
